var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"eye-icon",on:{"click":_vm.viewDetails}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'eye']}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }